import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, Maximize2 } from 'lucide-react';
interface SortableItemProps {
  id: string;
  children: React.ReactNode;
  size: 'small' | 'medium' | 'large';
  onSizeChange: (id: string, size: 'small' | 'medium' | 'large') => void;
  className?: string;
}
export function SortableItem({
  id,
  children,
  size,
  onSizeChange,
  className
}: SortableItemProps) {
  const [showSizeMenu, setShowSizeMenu] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };
  const getSizeLabel = (s: 'small' | 'medium' | 'large') => {
    switch (s) {
      case 'small':
        return 'Petite';
      case 'medium':
        return 'Moyenne';
      case 'large':
        return 'Grande';
    }
  };
  return <div ref={setNodeRef} style={style} className={`relative group ${className}`} data-id="element-1830">
      <div className="absolute top-2 right-2 z-10 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1831">
        <div className="relative" data-id="element-1832">
          <button onClick={() => setShowSizeMenu(!showSizeMenu)} className="p-1 bg-white rounded shadow-sm hover:bg-gray-50" title="Redimensionner" data-id="element-1833">
            <Maximize2 className="h-4 w-4 text-gray-400" data-id="element-1834" />
          </button>
          {showSizeMenu && <div className="absolute right-0 mt-1 w-32 bg-white rounded-md shadow-lg border border-gray-200 py-1" data-id="element-1835">
              {(['small', 'medium', 'large'] as const).map(s => <button key={s} onClick={() => {
            onSizeChange(id, s);
            setShowSizeMenu(false);
          }} className={`w-full text-left px-3 py-1.5 text-sm hover:bg-gray-100 ${size === s ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700'}`} data-id="element-1836">
                  {getSizeLabel(s)}
                </button>)}
            </div>}
        </div>
        <div {...attributes} {...listeners} className="p-1 bg-white rounded shadow-sm cursor-grab active:cursor-grabbing hover:bg-gray-50" data-id="element-1837">
          <GripVertical className="h-4 w-4 text-gray-400" data-id="element-1838" />
        </div>
      </div>
      {children}
    </div>;
}